import React, { useEffect, useState } from 'react';
import {
  PreviewContainer,
  AuthButton,
  Column,
  ContainerInteraction,
  Input,
  TagError,
  Text,
} from './styles';
import api from '../../services/api';
import { toast } from 'react-toastify';
import Toast from '../../components/Toast';

interface AuthGenerateBilletProps {
  id: string;
  databaseId: string;
  setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean | null>>;
}

const AuthGenerateBillet = ({
  id,
  databaseId,
  setIsAuthenticated,
}: AuthGenerateBilletProps) => {
  const [maskedCpf, setMaskedCpf] = useState<string | null>(null);
  const [errorDigit, setErrorDigit] = useState(false);
  const [digits6, setDigits6] = useState('');

  useEffect(() => {
    const fetchMaskedCpf = async () => {
      const maskedCpf = await api.rpaGetMaskedCpf({
        id: id.slice(0, -2),
        databaseId: Number(databaseId),
      });
      setMaskedCpf(maskedCpf);
    };
    fetchMaskedCpf();
  }, []);

  useEffect(() => {
    if (errorDigit && digits6.length > 0) {
      setErrorDigit(false);
    }
  }, [digits6]);

  const handleDigits = (value: string): void => {
    const digits = value.replace(/\s/g, '');
    setDigits6(digits);
  };

  const callToast = (): void => {
    toast.error(
      <Toast
        title={'Credenciais inválidas!'}
        description={'Por favor, verifique os seus dados e tente novamente.'}
      />
    );
  };

  const validateCpf = async (): Promise<void> => {
    const cpfIsValid = await api.rpaIsValidCpf({
      id: id.slice(0, -2),
      databaseId: Number(databaseId),
      partialCpf: digits6,
    });
    if (cpfIsValid) {
      setIsAuthenticated(cpfIsValid);
    } else {
      setErrorDigit(true);
      callToast();
    }
  };

  const submit = async () => {
    const isComplete = digits6
      .replace(/[^0-9]/g, '')
      .replace(/(\..*)\./g, '$1');

    if (errorDigit || !digits6 || isComplete.length !== 6) {
      setErrorDigit(true);
      callToast();
    } else {
      validateCpf();
    }
  };

  return (
    <>
      <Text>Para continuar, complete os 6 dígitos do seu CPF abaixo:</Text>
      <PreviewContainer>
        <span>{maskedCpf}</span>
      </PreviewContainer>
      <ContainerInteraction>
        <Column id='cpf'>
          <Input
            mask='9 9 9 9 9 9'
            id='cpf'
            alwaysShowMask={true}
            error={errorDigit}
            onChange={(e) => handleDigits(e.target.value)}
          />
          {errorDigit && <TagError>CPF inválido</TagError>}
        </Column>
        <AuthButton
          onClick={submit}
          disabled={digits6.length > 0 ? false : true}
        >
          Entrar
        </AuthButton>
      </ContainerInteraction>
    </>
  );
};

export default AuthGenerateBillet;
